export const NOTIFICATION_TYPES = {
  VARIANT: "variant",
  PUBLISH: "publish",
  HIGHLIGHT: "highlight",
  RULE_ENGINE: "rule-engine",
  EXPORT: "clip-transform",
  COPILOT: "copilot",
  AUTOFLIP: "autoFlip",
  DYNAMICFLIP: "dynamicFlip",
  DOWNLOAD_VIDEO: "downloadVideoJob",
  SUBTITLE_GENERATION: "subtitle_generation",
  CENTER_CROP: "centerCrop",
};

export const NOTIFICATION_STATUS = {
  IN_PROGRESS: "inProgress",
  COMPLETED: "completed",
  FAILED: "failed",
  CANCELLED: "cancelled",
};

export const NOTIFICATION_TITLE = {
  [NOTIFICATION_TYPES.VARIANT]: {
    [NOTIFICATION_STATUS.IN_PROGRESS]: "A new variant is getting generated",
    [NOTIFICATION_STATUS.FAILED]: "Variant generation failed",
    [NOTIFICATION_STATUS.COMPLETED]: "A new variant has been created",
    [NOTIFICATION_STATUS.CANCELLED]: "Variant generation cancelled",
  },
  [NOTIFICATION_TYPES.PUBLISH]: {
    [NOTIFICATION_STATUS.IN_PROGRESS]: "We are publishing your clip",
    [NOTIFICATION_STATUS.FAILED]: "Publishing failed",
    [NOTIFICATION_STATUS.COMPLETED]: "Publishing completed",
    [NOTIFICATION_STATUS.CANCELLED]: "Publishing cancelled",
  },
  [NOTIFICATION_TYPES.EXPORT]: {
    [NOTIFICATION_STATUS.IN_PROGRESS]: "Exporting clip",
    [NOTIFICATION_STATUS.FAILED]: "Exporting failed",
    [NOTIFICATION_STATUS.COMPLETED]: "Exporting completed",
    [NOTIFICATION_STATUS.CANCELLED]: "Exporting cancelled",
  },
  [NOTIFICATION_TYPES.COPILOT]: {
    [NOTIFICATION_STATUS.IN_PROGRESS]: "Generating highlight",
    [NOTIFICATION_STATUS.FAILED]: "Generating highlight failed",
    [NOTIFICATION_STATUS.COMPLETED]: "Generating highlight completed",
    [NOTIFICATION_STATUS.CANCELLED]: "Highlight generation cancelled",
  },
  [NOTIFICATION_TYPES.HIGHLIGHT]: {
    [NOTIFICATION_STATUS.IN_PROGRESS]: "Generating a highlight",
    [NOTIFICATION_STATUS.FAILED]: "Highlight generation failed",
    [NOTIFICATION_STATUS.COMPLETED]: "Highlight generated",
    [NOTIFICATION_STATUS.CANCELLED]: "Highlight generation cancelled",
  },
  [NOTIFICATION_TYPES.RULE_ENGINE]: {
    [NOTIFICATION_STATUS.IN_PROGRESS]: "Generating a highlight via Rule",
    [NOTIFICATION_STATUS.FAILED]: "Highlight generation via Rule failed",
    [NOTIFICATION_STATUS.COMPLETED]: "Highlight generated via Rule",
    [NOTIFICATION_STATUS.CANCELLED]: "Highlight generation via Rule cancelled",
  },
  [NOTIFICATION_TYPES.AUTOFLIP]: {
    [NOTIFICATION_STATUS.IN_PROGRESS]: "Generating a clip via Auto Flip",
    [NOTIFICATION_STATUS.FAILED]: "Clip generation via Auto Flip failed",
    [NOTIFICATION_STATUS.COMPLETED]: "Clip generated via Auto Flip",
    [NOTIFICATION_STATUS.CANCELLED]: "Clip generation via Auto Flip cancelled",
  },
  [NOTIFICATION_TYPES.DYNAMICFLIP]: {
    [NOTIFICATION_STATUS.IN_PROGRESS]: "Generating a clip via Dynamic Flip",
    [NOTIFICATION_STATUS.FAILED]: "Clip generation via Dynamic Flip failed",
    [NOTIFICATION_STATUS.COMPLETED]: "Clip generated via Dynamic Flip",
    [NOTIFICATION_STATUS.CANCELLED]: "Clip generation via Dynamic Flip cancelled",
  },
  [NOTIFICATION_TYPES.DOWNLOAD_VIDEO]: {
    [NOTIFICATION_STATUS.IN_PROGRESS]: "Downloading match video",
    [NOTIFICATION_STATUS.FAILED]: "Match video download failed",
    [NOTIFICATION_STATUS.COMPLETED]: "Match video download completed",
    [NOTIFICATION_STATUS.CANCELLED]: "Match video download cancelled",
  },
  [NOTIFICATION_TYPES.SUBTITLE_GENERATION]: {
    [NOTIFICATION_STATUS.IN_PROGRESS]: "Generating subtitles",
    [NOTIFICATION_STATUS.FAILED]: "Subtitle generation failed",
    [NOTIFICATION_STATUS.COMPLETED]: "Subtitle generation completed",
    [NOTIFICATION_STATUS.CANCELLED]: "Subtitle generation cancelled",
  },
  [NOTIFICATION_TYPES.CENTER_CROP]: {
    [NOTIFICATION_STATUS.IN_PROGRESS]: "Generating a clip via Center Crop",
    [NOTIFICATION_STATUS.FAILED]: "Clip generation via Center Crop failed",
    [NOTIFICATION_STATUS.COMPLETED]: "Clip generation via Center Crop completed",
    [NOTIFICATION_STATUS.CANCELLED]: "Clip generation via Center Crop cancelled",
  },
};
